import { memo, useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import { SwitchField } from "@/components/ui/form/fields/switch-field";

import { ManagementECReceiptDetailVoucherIssuedSectionLabelAndTitleItem as LabelAndTitleItem } from "../_shared/label-and-title-item";

import type { ViewData } from "../../../../model/type";

type Props = {
	voucherIssuedList: ViewData["voucherIssuedList"];

	onMarkVoucher: (voucherCode: string, isUsed: boolean, receiptID: string) => Promise<void>;
};

export const ManagementECReceiptDetailVoucherIssuedListSection = memo(({ voucherIssuedList, onMarkVoucher }: Props) => {
	const handleMarkVoucher = useCallback(
		async ({ voucherCode, isUsed, receiptID }: { voucherCode: string; isUsed: boolean; receiptID: string }) => {
			await onMarkVoucher(voucherCode, isUsed, receiptID);
		},
		[onMarkVoucher],
	);

	return (
		<div className="space-y-4">
			<h4>宿泊券一覧</h4>
			<div className="space-y-4">
				{voucherIssuedList.map((voucher, index) => {
					const sellingPriceText = `${voucher.voucherMast.sellingPrice.toLocaleString()}円`;
					const voucherPriceText = `${voucher.voucherMast.voucherPrice.toLocaleString()}円`;

					return (
						<div key={index} className="rounded border border-zinc-200 p-4">
							<div className="flex items-center justify-between gap-x-4">
								<div className="space-y-4">
									<LabelAndTitleItem label="宿泊券番号" value={voucher.voucherCode} />
									<LabelAndTitleItem label="宿泊券名" value={voucher.voucherMast.name} />
									<LabelAndTitleItem label="説明" value={voucher.voucherMast.description} />

									<LabelAndTitleItem label="販売価格" value={sellingPriceText} />
									<LabelAndTitleItem label="適用価格" value={voucherPriceText} />
								</div>

								<div className="flex shrink-0 flex-col items-center">
									<SwitchField
										value={voucher.isUsed}
										handleInput={() =>
											handleMarkVoucher({
												voucherCode: voucher.voucherCode,
												isUsed: voucher.isUsed,
												receiptID: voucher.userECReceiptID,
											})
										}
									/>
									<div className="flex gap-x-1 text-xs">
										<p
											className={cn(
												!voucher.isUsed ? "font-semibold text-zinc-600" : "text-zinc-300",
											)}
										>
											未使用
										</p>
										<p>/</p>
										<p
											className={cn(
												voucher.isUsed ? "font-semibold text-zinc-600" : "text-zinc-300",
											)}
										>
											使用済
										</p>
									</div>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
});

ManagementECReceiptDetailVoucherIssuedListSection.displayName = "ManagementECReceiptDetailVoucherIssuedListSection";
